(function(win, doc){
    var g_firstTitle = $('.al-post-column h2')[0];
    var g_toc = $('.al-simpletoc')[0];
    var g_leftPanel = $('.al-post-column-toc')[0];
    var g_addedOnHeading = false;

    // Get all the heading elements in the document
    const headings = $('h2', $('.al-post-content')[0]);

    // Function to determine if an element is in viewport
    const isInViewport = (elem, index) => {
        const bounding = elem.getBoundingClientRect();
        return (
            bounding.top < 77
        );
    };
    
    // Function to update the active heading in the sidebar menu
    const updateActiveHeading = () => {
        let activeHeading = null;
        let activeHeadingIndex = 0;
        var found = false;

        // Find the first heading that is currently in viewport
        headings.forEach(function(heading, index){
            if (isInViewport(heading, index) && !found) {
                activeHeading = heading;
                activeHeadingIndex = index;
            }
        });

        if(!activeHeading){
            activeHeading = headings[0];
        }

        // Highlight the active heading in the sidebar menu
        if (activeHeading) {
            const sidebarLinks = $('.simpletoc-list a');
            sidebarLinks.forEach(function(link, index){
                removeClass(link, 'active');
                if(index === activeHeadingIndex){
                    addClass(link, 'active');
                }
            });
        }
    };

    let resizeTimer;

    function onResize(){
        // Throttle the resize event using requestAnimationFrame
        if (!resizeTimer) {
            resizeTimer = requestAnimationFrame(() => {
                resizeTimer = null;
                checkWidth();
            });
        }
    }

    bindEvents();
    onResize();

    function bindEvents(){
        doc.addEventListener("scroll", onScroll, {passive: true});
        win.addEventListener("resize", onResize, {passive: true});
    }

    let lastKnownScrollPosition = 0;
    let ticking = false;

    // https://developer.mozilla.org/en-US/docs/Web/API/Document/scroll_event
    function onScroll(event){
        lastKnownScrollPosition = win.scrollY;

        if (!ticking) {
            win.requestAnimationFrame(() => {
                updateActiveHeading();
                ticking = false;
            });

            ticking = true;
        }
    }

   

    function checkWidth() {
        // Check if the document width is less than 500px
        if (doc.documentElement.clientWidth < 1120) {
            addBeforeTitle();
        }
        else{
            addToLeftPanel();
        }
    }

    $('.al-simpletoc li').forEach(function(item){
        item.querySelector('a').addEventListener('click', function(e){
            removeClass($('.al-simpletoc a.active')[0], 'active');
            addClass(e.currentTarget, 'active');
        });
    });

    var nav = $('.al-simpletoc')[0];
    if(nav && nav.offsetHeight > win.innerHeight){
        nav.style.position = 'relative';
    }

    function addBeforeTitle(){
        var isListSmall = $('li', g_toc).length < 10;
        if(g_firstTitle && g_toc && !g_addedOnHeading && isListSmall){
            addClass(g_toc, 'al-simpletoc-mobile');
            g_firstTitle.parentNode.insertBefore(g_toc, g_firstTitle);
            g_addedOnHeading = true;
        }
    }

    function addToLeftPanel(){
        if(g_addedOnHeading){
            g_leftPanel.appendChild(g_toc);
            removeClass(g_toc, 'al-simpletoc-mobile');
            g_addedOnHeading = false;
        }
    }

    function addClass(el, className){
        el.classList.add(className);
    }
    function removeClass(el, className){
        el.classList.remove(className);
    }

    /**
    * Equivalent of jQuery function $().
    */
    function $(selector, context){
        context = arguments.length > 1 ? context : doc;
        return context ? context.querySelectorAll(selector) : null;
    }

})(window, document);